// extracted by mini-css-extract-plugin
export var boldText = "_7j-4";
export var checkboxContainer = "_7j-6";
export var closeIcon = "_7j-i";
export var container = "_7j-0";
export var drawer = "_7j-8";
export var drawerContent = "_7j-9";
export var extraSmallText = "_7j-5";
export var fulfillmentGroupTable = "_7j-e";
export var largeText = "_7j-3";
export var loadingSpinnerContainer = "_7j-j";
export var mediumText = "_7j-2";
export var narrow = "_7j-f";
export var notificationLink = "_7j-l";
export var packageCheckIconContainer = "_7j-7";
export var slideoutHeaderActions = "_7j-g";
export var slideoutHeaderActionsShifted = "_7j-h";
export var slideoutHeaderContainer = "_7j-a";
export var slideoutModal = "_7j-c";
export var stickyHeaderWrapper = "_7j-b";
export var table = "_7j-k";
export var tableContainer = "_7j-d";
export var tertiaryText = "_7j-1";